<template>
  <v-flex class="main-flex">
    <div style="flex-grow: 1; width: 600px" v-if="!showTerms">
      <v-form class="main-flex" @submit="preventSubmit">
        <v-row style="width: 100%; align-items:center">
          <v-col
            cols="12"
            style="display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;"
          >
            <v-col
              cols="12"
              style="color: #fff; border-radius: 4px; padding: 20px;"
            >
              <h2>
                Välkomment till Percap Admin!
              </h2>
              <p>
                Vi kräver ingen komplicerad registrering. Det enda du behöver
                göra är att logga in i Admin med Mobilt BankID.<br />
                När du väl är inloggad kan du skapa din första organisation och
                möten.<br />
                Allt är gratis upp till fem rösträtter, så du kan testa Percap i
                lugn och ro.
              </p>
              <!--              <Onboarding></Onboarding>-->
            </v-col>
            <v-col class="flex-grow-0 flex-shrink-0 text-center">
              <v-btn @click="loginUser" width="330px" height="46px">
                <span>Logga in med Mobilt BankID </span>
              </v-btn>
            </v-col>
          </v-col>
        </v-row>
        <v-row style="width: 100%; align-items:center">
          <v-col
            cols="12"
            style="display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;"
          >
            <v-col
              cols="12"
              style="color: #fff;
            border-radius: 4px;
            padding: 20px;
            margin-top: 10px"
            >
              <h2>
                Är du inbjuden till ett möte?
              </h2>
              <p>
                Som deltagare i ett möte ska du istället gå till
                <a href="https://percap.app" style="color: #fff">
                  https://percap.app</a
                >
              </p>
            </v-col>
            <v-col class="flex-grow-0 flex-shrink-0 text-center">
              <v-btn href="https://percap.app" width="330px" height="46px">
                <span>Öppna percap.app</span>
              </v-btn>
            </v-col>
          </v-col>
        </v-row>
      </v-form>
      <v-overlay :value="loading" :opacity="0.8">
        <v-row>
          <v-col style="flex-grow:0;">
            <qrcode-vue
              v-if="qrVisible"
              :size="200"
              :value="qrcode"
              level="L"
            ></qrcode-vue>
            <v-progress-circular v-else indeterminate :size="160" />
          </v-col>
          <v-col>
            <h3>Verifiera dig med bankid</h3>
            <p>Öppna mobilt bankid och scanna QR-koden.</p>
            <v-btn @click="cancelAuth" small light>Avbryt</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="null != autostartToken">
          <v-btn @click="bankIdAutoStart" light>
            Starta bank-id på denna enhet
          </v-btn>
        </v-row>
      </v-overlay>
    </div>
    <v-row
      v-if="showTerms"
      no-gutters
      class="organizations flex flex-grow-1 flex-shrink-1"
      style="flex-flow: column; flex-wrap: nowrap; width: 600px;"
    >
      <div class="main-flex">
        <div class="flex-grow-0 flex-shrink-0">
          <div
            style="display: flex; justify-content: space-between; padding-bottom: 10px;"
          >
            <h3 class="white--text">Användarvillkor</h3>
          </div>
        </div>
        <v-card
          id="scroll-target"
          class="flex-grow-1 flex-shrink-1 overflow-y-auto"
          elevation="4"
          style="height: 100%;max-height:300px;"
        >
          <v-card-text>
            <h1>Avtal för licens</h1>
            <p>
              LÄS NOGGRANT IGENOM DETTA AVTAL FÖR LICENSTJÄNSTER FÖRE KÖP AV
              LICENSTJÄNSTER FRÅN PERCAP AB (“PERCAP”). GENOM ATT ANVÄNDA
              LICENSTJÄNSTERNA FRÅN PERCAP, SAMTYCKER OCH GODKÄNNER KUNDEN DETTA
              AVTAL FÖR LICENSTJÄNSTER OCH BEKRÄFTAR ATT HAN/HON HAR LÄST OCH
              FÖRSTÅTT AVTALET. OM KUNDEN INTE GODKÄNNER VILLKOREN I AVTALET,
              SKA DENNE INTE ANVÄNDA LICENSTJÄNSTERNA FRÅN PERCAP.
            </p>
            <p>
              Detta avtal för licenstjänster (avtalet för licenstjänster)
              innehåller villkor enligt vilka PERCAP tillhandahåller sin
              programvara ”Percap” (programvaran) som ägs av PERCAP. Avtalet för
              licenstjänster gäller och omfattas, genom denna hänvisning, även
              av PERCAPs allmänna villkor som tillhandahålls som bilaga 1.
              Kunden har läst, förstått och godkänt alla villkoren i avtalet.
              Vid eventuell intressekonflikt eller oöverensstämmelse mellan
              dokumenten, ska rangordningen vara följande: (1) https://percap.se
              (2) detta avtal för licenstjänster, (3) bilaga 1 PERCAPs allmänna
              villkor.
            </p>
            <h2>1. Omfattning, användning av LICENSTJÄNSTERNA</h2>
            <p>
              I enlighet med villkoren i detta avtal för licenstjänster, lovar
              PERCAP att tillhandahålla och kunden lovar att ta emot och betala
              för LICENSTJÄNSTERNA för nyttjande av engångslicens enligt avtalat
              pris per rösträtt enligt https://www.percap.se/ (om inget annat
              angetts). Nyttjandeperioden avser nyttjande av licenser avsett för
              ett specifikt tillfälle. För varje nytt nyttjande är kunden
              skyldighet att erlägga en betalning enligt villkor för
              LICENSTJÄNSTERNA. Perioden för tjänsterna avräknas från
              LICENSTJÄNSTERNAS nyttjande datum. För att kunna nyttja tjänsten
              på utsatt datum skall kunden betala för totalt antal rösträtter
              som finns i föreningen eller organisationen med kredit- eller
              kontokort om inget annat avtalats.
            </p>
            <p>
              Kunden får endast använda licenstjänster för internt bruk om inget
              annat avtalats. Kunden är skyldig att betala avgifterna enligt
              https://percap.se/priser för varje rösträtt som läggs in i
              systemet för deltagande på den digitala stämman. Med rösträtt
              avses dem som har rätt att rösta i föreningen eller
              organisationen. Om flera personer delar på en rösträtt debiteras
              kunden endast för en (1) rösträtt.
            </p>
            <p>
              Att distribuera licenstjänsten till tredje part, utan att ha
              ingått i ett partneravtal, är ett väsentligt brott mot avtalet för
              LICENSTJÄNSTERNA.
            </p>
            <p>
              Licenstjänsten får användas av tredje part enligt villkoren i
              detta avtal för licenstjänster om denne agerar på kundens vägnar
              såsom entreprenör, underentreprenör eller konsult, förutsatt att
              kunden förblir ansvarig för alla sina skyldigheter enligt detta
              avtal för licenstjänster för tredjeparts aktiviteter och
              försummelse.
            </p>
            <h2>2. Krav på köp, villkor och betalning</h2>
            <p>
              Såvida Percap inte beslutar om annat så får kunden endast köpa
              inledande licenstjänster för den senaste allmänt tillgängliga
              releasen av programvaran.
            </p>
            <p>
              Det finns ingen bindningstid och kunden betalar endast för de
              tillfällen kunden avser att nyttja tjänsten. Kundens instans med
              genomförda möten finns kvar i administratörsgränssnittet utan
              kostnad. Avtalets villkor gäller så länge kundens instans finns
              kvar i administratörsgränssnittet.
            </p>
            <p>
              PERCAP kan säga upp detta avtal för licenstjänster genom att
              skriftligen underrätta kunden minst 90 dagar före början av nästa
              faktureringsperiod. Prisjusteringar för Licenstjänsten börjar
              gälla från och med den nästkommande förnyelseperiod som följer på
              datumet för prisjusteringen. Genom att fortsätta använda
              Licenstjänsten efter att prisjusteringen börjat gälla, anses
              kunden ha godkänt det nya priset.
            </p>
            <h2>3. Undantag</h2>
            <p>
              LICENSTJÄNSTERNA täcker inte problem som orsakas av följande:
            </p>
            <p>
              1. Ovanliga, externa fysiska faktorer såsom stränga
              väderförhållanden som orsakar elektrisk eller elektromagnetisk
              spänning eller strömavbrott, luftkonditionering eller
              fuktighetsreglering, försummelse, missbruk, drift av programvaran
              med andra media, eller orsaker andra än normal användning
            </p>
            <p>
              2. Användning av programvaran på sätt som avviker från de
              driftsprocedurer som specificeras i tillämplig produkthandbok
            </p>
            <p>
              3. Tredjeparts-produkter andra än gränssnittet till programvaran
              med tredjeparts-produkter
            </p>
            <p>
              4. Ändrad kod
            </p>
            <p>
              5. Problem som rör programvara som erbjuds som en tjänst
            </p>
            <p>
              6. Alla skräddarsydda leverabler som skapats av PERCAP, PERCAPs
              partners eller tredjeparts tjänsteleverantörer som är specifika
              för kunden och en del av en konsulttjänst
            </p>
            <p>
              7. Användning av programvaran med verktyg som inte ingår, API:er,
              gränssnitt eller dataformat annat än de som ingår i programvaran
              och som stöds enligt produkthandboken. Kunden kan begära hjälp
              från Percap för sådana problem, mot en tilläggskostnad. Percap
              besvarar dessa förfrågningar efter Percaps gottfinnande gällande
              förfrågans utförbarhet.
            </p>
            <p>
              PERCAP kan närsomhelst, utan avisering eller
              skadeståndsskyldighet, begränsa tillgången till LICENSTJÄNSTERNA
              för att kunna genomföra underhållsaktiviteter. Underhåll genomförs
              i största möjliga mån på tider då Percap anser att nyttjandet av
              licenstjänsten är låg.
            </p>
            <p>
              PERCAP kan, enligt eget gottfinnande, besluta att dra tillbaka
              LICENSTJÄNSTERNA från tid till annan (slut på åtkomst). Percap ska
              skriftligen tillkännage uppsägning inklusive den sista dagen som
              berörda licenstjänster är allmänt kommersiellt tillgängliga med
              tidplan för upphörande av tjänsterna, minst nittio (90) dagar
              innan tjänsten upphör. PERCAP har ingen skyldighet att
              tillhandahålla föråldrad programvara eller licenstjänster för
              föråldrad programvara.
            </p>
            <h2>4. Support</h2>
            <p>
              PERCAP tillhandahåller endast driftsupport till kunden (gratis
              testversion ingår) via e-post: support@percap.se . PERCAP kan
              tillhandahåller ej support eller teknisk hjälp för hur man
              installerar eller nyttjar licenstjänsten. För användarsupport och
              teknisk hjälp hänvisar PERCAP till licenstjänsternas
              produktmanualer alternativt någon av PERCAPS tjänstepartners.
              Felanmälan via e-post kan tas emot dygnet runt, eventuella svar
              sker under kontorstid (8:00-17:00) helgfria Svenska vardagar. Vid
              eventuell driftstörning åligger det KONDESATORS ansvar att åtgärda
              felet så fort som möjligt. Kunden godkänner genom detta avtal att
              Percap inte garanterar att rapporterade fel hanteras inom en viss
              tidsrymd om inget annat avtalats.
            </p>
            <h2>5. Bevilja licens</h2>
            <p>
              Kunden erkänner och är införstådd med att LICENSTJÄNSTERNA
              använder programvara som ägs av PERCAP och att kunden beviljas en
              enskild, icke-exklusiv och icke-överlåtbar licens för att använda
              programvaran enligt villkoren i detta avtal för licenstjänster.
              Kunden erkänner och är införstådd med att kunden, kundens
              medarbetare eller ombud uttryckligen förbjuds: att direkt eller
              indirekt försöka ta reda på källkoden, underliggande algoritmer
              eller tekniken i programvaran, att hyra ut, leasa, sälja, tilldela
              eller överlåta rättigheterna till programvaran, att ändra eller
              skapa härledda verk grundat på programvaran, om inget annat
              avtalats. Kunden erkänner och är införstådd med att PERCAP
              behåller exklusiv ägarrätt till sin programvara, inklusive delar
              av den eller kopior och att alla rättigheter som inte uttryckligen
              beviljats kunden i detta avtal för licenstjänster tillhör PERCAP.
            </p>
            <p>
              Licenser som är tillämpliga för de enskilda öppna
              källkodsprogramvarupaketen är eviga (förutsatt att kundens följer
              deras villkor), medan andra nyttor i en licenstjänst och dess
              programvara upphör att gälla i slutet av tjänstens period om de
              inte förnyas.
            </p>
            <h2>6. Immateriella rättigheter, tredjeparts överträdelse</h2>
            <p>
              Programvara och dokumentation, alla kopior och delar av dessa samt
              alla förbättringar, all utveckling, ändringar och härledda verk
              från dessa, liksom alla immateriella rättigheter här i, är och ska
              förbli PERCAPS och/eller deras licensgivares egendom med
              ensamrätt.
            </p>
            <p>
              Kundens rätt att använda programvara och dokumentation är
              begränsade till det som uttryckligen anges i avtalet för
              LICENSTJÄNSTERNA. Inga andra rättigheter avseende programvaran
              eller relaterade immateriella rättigheter är underförstådda.
              Kunden tillåts inte använda programvaran, dokumentationen eller
              någon del därav, förutom vad som uttryckligen tillåts i detta
              avtal för licenstjänster.
            </p>

            <h1>Percaps allmänna villkor</h1>
            <p>
              Dessa allmänna villkor (allmänna villkor) innehåller de allmänna
              villkoren enligt vilka Percap tillhandahåller sin programvara
              (programvaran) och driftsupport till sin kund enligt ett separat
              avtal för Licenstjänster (tillsammans avtalet).
            </p>
            <h2>1. Villkor och begrepp</h2>
            <p>
              Dessa allmänna villkor gäller alla produkter som köps och/eller
              licensieras från Percap. De allmänna villkoren fortsätter att
              gälla så länge som avtalet mellan parterna för Licenstjänsterna
              gäller. Om inget annat anges i dessa allmänna villkor så gäller
              samma begrepp som i avtalet för Licenstjänster.
            </p>
            <h2>2. Utvärdering eller provlicens</h2>
            <p>
              Om kunden beviljas licens till Percaps programvara i syfte att
              utvärdera eller prova det, tillåts kunden endast använda
              programvaran i en icke-produktionsmiljö och för en begränsad
              period enligt överenskommelse. Oaktat eventuell annan bestämmelse
              i avtalet så tillhandahålls en utvärderings- och provlicens av
              programvaran ”som den är” utan skadeersättning, support eller
              garanti av något slag, uttryckligen eller underförstått.
            </p>
            <h2>3. Betalning</h2>
            <p>
              Icke avtalskunder betalar för tjänsten i med kortbetalning i
              förskott. Vid avtalsfakturering fakturerar Percap kunden den 20e
              varje månad. Betalning ska ske inom trettio (30) kalenderdagar
              efter fakturadatum.
            </p>
            <p>
              Vid försenad betalning ska kunden betala dröjsmålsränta enligt den
              svenska räntelagen 6 § (1975:635).
            </p>
            <h2>4. Partnernas allmänna åtaganden</h2>
            <p>
              4.1 Percaps åtaganden för Licenstjänster omfattar följande:
            </p>
            <p>
              4.1.1 Kunden godkänner att ta emot kommunikation via e-post,
              telefon och andra format från Percap som avser Licenstjänsterna
              (t.ex. kommunikation som rör supportens omfattning eller andra
              tekniska frågor, tillgängligheten till nya releaser av
              programvaran samt utbildningsmöjligheter).
            </p>
            <p>
              4.1.2 Kunden är ensamt ansvarig för sin personals användning av
              licenstjänsten och ska ge personalen adekvat utbildning i
              användning och tillämpning av licenstjänsten.
            </p>
            <p>
              4.1.3 Kunden ska omgående rapportera alla problem med
              licenstjänsten till Percap och ska implementera eventuella
              rättelser som Percap förser dem med inom rimlig tid efter
              mottagandet.
            </p>
            <p>
              4.1.4 Kunden ska förse Percap med all information, åtkomst och
              fullt samarbete i god tro som rimligen kan vara nödvändigt för att
              underlätta tillhandahållandet av Licenstjänsterna och ska göra
              allt som fastställts som kundens ansvar. Kundens försummelse eller
              försening av ovanstående fritar Percap från sina åtaganden under
              detta avtal för Licenstjänster, i den mån som sådana åtaganden är
              beroende av kundens prestation.
            </p>
            <p>
              4.1.5 Percap ansvarar inte för förlorad data eller information om
              fel eller tekniska problem uppstår med licenstjänsten eller för
              datorer eller mobila enheter i vilka licenstjänsten används.
            </p>
            <p>
              4.1.6 Kunden ansvarar ensamt för att ha rutiner utanför
              licenstjänsten för rekonstruktion av förlorade eller ändrade
              filer, data eller program i den omfattning som anses nödvändig och
              för att kunna utföra sådan rekonstruktion.
            </p>
            <p>
              4.1.7 Det är kundens ansvar att införskaffa och underhålla lämplig
              utrustning och extra tjänster som krävs för att ansluta till, ha
              tillgång till eller på annat sätt använda licenstjänsten,
              inklusive men inte begränsat till mobila enheter, datorer,
              operativsystem, datalagring, nätverksenheter och webbläsare.
            </p>
            <h2>5. Ansvarsbegränsning</h2>
            <p>
              5.1 Percaps sammanlagda och kumulativa ansvar som följer av eller
              avser detta avtal och alla orderbekräftelser, oberoende av orsaken
              till omständigheten och oavsett om det anges i avtal, i lagen
              eller på annat sätt, begränsas till direkta skador och kan inte
              överstiga den summa som kunden har betalat (eller som förfaller
              till betalning) till Percap enligt den lämpligaste
              orderbekräftelsen som föranleder betalningsskyldighet under de
              tolv (12) månader som följer direkt på den incident som orsakade
              att ansvaret görs gällande.
            </p>
            <p>
              5.2 Oaktat något som talar emot innehållet häri eller i en
              orderbekräftelse, så kan inte Percap i något fall bli
              skadeståndsskyldig gentemot kunden eller dennes dotterbolag för
              (i) något skadeståndskrav som grundar sig på en tredje parts krav
              och (ii) oavsiktliga följd- eller indirekta skador, antingen de
              uppkommit under detta avtal eller annat på annat sätt.
            </p>
            <p>
              5.3 För att undvika missförstånd så ska följande slag av förlust
              och/eller skada inte utgöra direkt förlust i enlighet med syftena
              i detta avtal och/eller någon orderbekräftelse: förlust av data,
              utebliven vinst, förlust av sparkapital, förlust eller avbrott i
              tjänsten, utebliven vinst eller förmodade vinster,
              användningsförlust eller nertid, förlust av eller skada på data
              eller annan information, eller förlust eller skada på programvara
              även om kunden eller kundens dotterbolag har fått kännedom om
              risken för sådan förlust och/eller skada.
            </p>
            <h2>6. Force majeure</h2>
            <p>
              6.1 En part försening eller försumbarhet i sina åtaganden enligt
              avtalet är ursäktligt om det orsakats av force majeure.
            </p>
            <p>
              6.2 I detta avtal innebär ”force majeure” en orsak eller händelse
              som inte rimligen kan förutses eller som på annat sätt orsakats av
              eller under den parts kontroll som hävdar force majeure, inklusive
              men inte begränsat till oförutsedda händelser, eldsvåda,
              översvämning, explosioner, upplopp, krig, orkan, sabotage,
              terrorism, vandalism, olycka, statens begränsning, offentliga
              åtgärder eller sanktioner och andra liknande händelser som ligger
              bortom den berörda partens rimliga förutseende och kontroll, trots
              partens rimliga ansträngning att förebygga, undvika, försena eller
              mildra effekten av sådan handling, händelse eller förekomst och
              där händelserna eller effekterna av dem inte härrör från partens
              underlåtenhet att efterleva sina åtaganden enligt detta avtal.
            </p>
            <p>
              6.3 Om en part önskar åberopa force majeure ska denne omedelbart
              informera den andra parten om detta.
            </p>
            <h2>7. Övriga villkor</h2>
            <p></p>
            <h3>7.1 Avtalsbrott</h3>
            <p>
              Förutom det som anges på annat ställe i avtalet om Licenstjänster,
              kan Percap säga upp avtalet och alla Licenstjänster när som helst
              om (1) det upptäckts att kunden bryter mot begränsningarna i sin
              programvarulicens eller om (2) kunden väsentligen bryter mot detta
              avtal.
            </p>
            <h3>7.2 Information och personuppgifter</h3>
            <p>
              7.2.1 Kunden är införstådd med att korrespondens och loggfiler som
              genereras i samband med en begäran om Licenstjänster och/eller
              support kan innehålla känslig, konfidentiell eller personlig
              information. Kunden är ensamt ansvarig för att vidta de åtgärder
              som denne anser nödvändiga för att skydda sådana data, inklusive
              att dölja loggar eller på annat sätt skydda sådan information
              innan de skickar den till Percap.
            </p>
            <p>
              7.2.2 Kunden godkänner att Percap får behandla teknisk och
              relaterad information om kundens användning av programvaran som
              kan omfatta IP-adresser, hårdvaruidentifiering, operativsystem,
              applikationsprogramvara, kringutrustning och statistik över
              icke-identifierbar programvara avseende personanvändning, för att
              underlätta tillhandahållandet av uppdateringar, support,
              fakturering och online-tjänster.
            </p>
            <p>
              7.2.3 I den omfattning som Percap behandlar information på kundens
              vägnar som innehåller personuppgifter enligt
              Dataskyddsförordningen / GDPR (The General Data Protection
              Regulation), ska kunden vara registeransvarig för sådana
              personuppgifter och Percap ska vara assistent för personuppgifter,
              där båda vid varje tidpunkt, ska uppfylla sina skyldigheter enligt
              den europeiska lagstiftningen för skydd av personer avseende
              behandling av personuppgifter.
            </p>
            <h3>7.3 Enskilda avtalsbestämmelsers ogiltighet</h3>
            <p>
              Om någon av bestämmelserna i detta avtal av någon anledning skulle
              bli ogiltig eller icke-verkställbar, men skulle bli giltig och
              verkställbar med lämplig ändring, så ska sådan bestämmelse
              tillämpas med nödvändig ändring för att göra den giltig och
              verkställbar. Om bestämmelsen inte kan ändras, är parterna överens
              om att den inte ska påverka giltigheten för resterande
              bestämmelser i avtalet.
            </p>
            <h3>7.4 Undantag</h3>
            <p>
              En försening eller försummelse från endera parten att utnyttja
              någon av sina rättigheter i detta avtal, ska inte utgöra eller
              betraktas som undantag från eller förverkande av sådana
              rättigheter. Inget undantag är giltigt utan att vara skriftligt
              och undertecknat av en godkänd representant för den part som söker
              sådant undantag.
            </p>
            <h3>7.5 Hela avtalet</h3>
            <p>
              Detta avtal omfattar hela överenskommelsen mellan parterna
              avseende innehållet i Licenstjänsterna och ersätter alla tidigare
              eller samtida kommunikationer, framställanden, erbjudanden,
              åtaganden, förklaringar och överenskommelser, antingen skriftliga
              eller muntliga mellan parterna som avser innehållet häri.
            </p>
            <h3>7.6 Ändringar</h3>
            <p>
              Detta avtal får endast ändras skriftligen och ska undertecknas av
              representanter för båda parter.
            </p>
            <h2>8. Tvistelösning, tillämplig lagstiftning</h2>
            <p>
              8.1 Alla tvister, meningsskiljaktigheter eller anspråk med
              anledning av detta avtal, eller överträdelse, uppsägning eller
              ogiltighet för detta, ska slutligen avgöras genom
              skiljedomsförfarande enligt skiljedomsreglerna hos Stockholms
              Handelskammare (SCC).
            </p>
            <p>
              8.2 Reglerna för förenklat skiljeförfarande ska gälla, såvida inte
              SCC enligt eget gottfinnande, med hänsyn tagen till ärendets
              komplexitet och beloppet som tvisten gäller eller andra
              omständigheter, beslutar att skiljedomsreglerna ska gälla. I det
              senare fallet, ska SCC också avgöra om skiljedomstolen ska bestå
              av en eller tre skiljedomare.
            </p>
            <p>
              8.3 Detta avtal ska gälla under Sveriges materiella rättsregler.
              Platsen för skiljedom ska vara Stockholm, Sverige.
            </p>
          </v-card-text>
        </v-card>
        <v-btn
          @click="approve"
          style="margin-top: 10px;
    align-self: flex-end;"
          >Jag godkänner</v-btn
        >
      </div>
    </v-row>
    <div style="flex-direction: end;">
      <div class="logo">
        <img src="../assets/images/text-logo.svg" />
      </div>
    </div>
  </v-flex>
</template>

<script>
import { isSSN } from "@/assets/lib/isSSN.js";
import QrcodeVue from "qrcode.vue";
// import Onboarding from "@/components/Onboarding";

export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      loading: false,
      showTerms: false,
      ssn: "",
      ssnRules: [
        v => isSSN(v) || `Måste vara ett personnummer i formatet ÅÅÅÅMMDDNNNN`
      ]
    };
  },
  computed: {
    auth() {
      return this.$store.getters["auth/auth"];
    },
    user() {
      return this.$store.getters["auth/user"];
    },
    isSSN() {
      return isSSN(this.ssn);
    },
    nextRoute() {
      return this.$route.query.redirect || "/";
    },
    qrcode() {
      return this.$store.getters["auth/qrcode"];
    },
    autostartToken() {
      return this.$store.getters["auth/autostartToken"];
    },
    qrVisible() {
      return this.qrcode !== "";
    }
  },
  watch: {
    auth(auth) {
      if (auth) {
        //this.$router.replace(this.nextRoute);
      }
    },
    user(user) {
      if (user && !user.hasAcceptedTerms) {
        this.showTerms = true;
      } else {
        this.$router.replace(this.nextRoute);
      }
    }
  },
  methods: {
    loginUser() {
      console.log("Login called...");
      this.loading = true;
      this.$auth.loginQr();
    },
    bankIdAutoStart() {
      const autostart = this.autostartToken;
      this.$auth.cancelQr();
      window.open(
        `https://app.bankid.com/?autostarttoken=${autostart}&redirect=`
      );
    },
    async approve() {
      const success = await this.$store.dispatch("auth/approveTerms", {
        uid: this.auth.uid
      });
      if (success) {
        this.$router.replace(this.nextRoute);
      }
    },
    cancelAuth() {
      this.$auth.cancelQr();
      this.loading = false;
    },
    preventSubmit(event) {
      event.preventDefault();
      //As of now, do nothing...
    }
  }
};
</script>

<style>
.main-flex {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.login {
  width: 90%;
  max-width: 500px;
  height: 100%;
}
.bankid {
  width: 100%;
}
.bankid img {
  width: 25%;
  margin: 20px;
}
.logo {
  padding: 20px;
}
.logo img {
  height: 40px;
}
#login .error--text {
  color: rgba(255, 255, 255, 0.7) !important;
}
</style>
